"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOURCES = exports.GetFieldError = void 0;
var get_1 = __importDefault(require("lodash/get"));
var constants_1 = require("../constants");
var funcError_1 = __importDefault(require("../funcError"));
var getSpecification_1 = __importDefault(require("../getSpecification"));
var GetFieldError = /** @class */ (function (_super) {
    __extends(GetFieldError, _super);
    function GetFieldError() {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        var _this = _super.apply(this, params) || this;
        _this.name = 'GetFieldError';
        return _this;
    }
    return GetFieldError;
}(funcError_1.default));
exports.GetFieldError = GetFieldError;
exports.SOURCES = {
    root: 'root',
    specification: 'specification',
};
/**
 * Получение различных полей из oбъекта car с заголовком
 * @param {object} car
 * @param {{ id: string, source: string, title?: string }} config
 * @returns {[string | undefined, any]}
 */
function getField(car, _a) {
    var source = _a.source, id = _a.id, title = _a.title, _b = _a.specGroup, specGroup = _b === void 0 ? constants_1.CAR_SPEC_MAIN : _b, value = _a.value;
    var result;
    // возвращаем кастомное значение
    if (value) {
        return [title, value];
    }
    switch (source) {
        case exports.SOURCES.root: {
            var value_1 = get_1.default(car, id);
            result = [title, value_1];
            break;
        }
        case exports.SOURCES.specification: {
            var value_2;
            var name_1;
            var measure = void 0;
            var specification = getSpecification_1.default(car.specification, specGroup, id, [
                'value',
                'name',
                'measure',
            ]);
            if (specification) {
                value_2 = specification[0], name_1 = specification[1], measure = specification[2];
            }
            var resolveTitle = void 0;
            if (title) {
                resolveTitle = title;
            }
            else if (name_1) {
                resolveTitle = measure && measure.length ? name_1 + ", " + measure : name_1;
            }
            result = [resolveTitle, value_2];
            break;
        }
        default:
            throw new GetFieldError(null, "Source \"" + source + "\" is not compatible");
    }
    return result;
}
exports.default = getField;
